import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import "normalize.css";
import { BrowserRouter } from "react-router";
import GridRegistrator from "./components/shared/GridRegistratorProvider";
import GridRegistratorProvider from "./components/shared/GridRegistratorProvider";
import AlertProvider from "./components/shared/ALertProvider";
import FromModalProvider from "./components/shared/FromModalProvider";
import InterceptorProvider from "./components/shared/InterceptorProvider";
// import {
//   ThemeProvider,
//   Toaster,
//   ToasterComponent,
//   ToasterProvider,
// } from "@gravity-ui/uikit";
// import "@gravity-ui/uikit/styles/fonts.css";
// import "@gravity-ui/uikit/styles/styles.css";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";

import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import LoadingPortal from "./components/shared/LoadingProvider";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <LocalizationProvider dateAdapter={AdapterMoment}>
      {/* <ThemeProvider theme="light"> */}
      <BrowserRouter>
        <GridRegistratorProvider>
          <AlertProvider>
            <FromModalProvider>
              <InterceptorProvider>
                <LoadingPortal>
                  <App />
                </LoadingPortal>
              </InterceptorProvider>
            </FromModalProvider>
          </AlertProvider>
        </GridRegistratorProvider>
      </BrowserRouter>
      {/* </ThemeProvider> */}
    </LocalizationProvider>
  </React.StrictMode>,
);
